import { useOrderNo } from '@shared/hooks/useOrderNo';

interface OrderNoInputProps {
  /** 受注ドキュメントID（内部FK） */
  orderId: string;
  /** 未紐付け時の手動入力ハンドラ（一覧からの単独作成フォールバック用） */
  onChange?: (orderId: string) => void;
  className?: string;
}

/**
 * 受注番号（案件番号）を表示する入力。
 * - 案件が紐づいている（orderId あり）場合は受注番号 "0001" を読取専用で表示する
 *   （Firestore の生ドキュメントID を画面に出さない）。
 * - 未紐付け（orderId 空）の場合のみ手動入力を許可する（一覧からの単独作成フォールバック）。
 */
export function OrderNoInput({ orderId, onChange, className }: OrderNoInputProps) {
  const orderNo = useOrderNo(orderId);

  if (orderId) {
    return <input value={orderNo ?? '—'} readOnly disabled className={className} />;
  }

  return (
    <input
      value={orderId}
      onChange={(e) => onChange?.(e.target.value)}
      className={className}
      placeholder="案件詳細から作成してください"
    />
  );
}
